/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import type { DegreePlan_LearnerAdmissionStatus as LearnerAdmissionStatus } from '__generated__/graphql-types';

import { Typography2 } from '@coursera/cds-core';

import HelpTipCardWithDialog from 'bundles/degree-home/components/v3-dpm/components/HelpTips/HelpTipCardWithDialog';
import { isFCND } from 'bundles/degree-home/components/v3-dpm/lib/otherUtils';

import _t from 'i18n!nls/degree-home';

const styles = {
  margin: () => css`
    margin-bottom: var(--cds-spacing-200);
  `,
};

const TipReadyToEarnMoreCredit = ({ learnerAdmissionStatus }: { learnerAdmissionStatus: LearnerAdmissionStatus }) => {
  if (!isFCND(learnerAdmissionStatus)) {
    return null;
  }

  return (
    <HelpTipCardWithDialog
      title={_t('Ready to earn more credit?')}
      tip={_t('Enroll in a for-credit degree course and keep earning credits')}
      dialogTitle={_t('Ready to earn more credit?')}
      dialogMessage={
        <React.Fragment>
          <Typography2 component="p" css={styles.margin}>
            {_t(
              "If you haven't been admitted to the program yet, you can enroll in any class that is part of the curriculum. Finish the course, and you'll earn credit you can use toward your degree once you're admitted."
            )}
          </Typography2>
          <Typography2 component="p" css={styles.margin}>
            {_t(
              'Each university determines the number of pre-approved credits that may count towards the degree requirements according to institutional policies. Check your student handbook or ask your program support team for more information on your program.'
            )}
          </Typography2>
        </React.Fragment>
      }
    />
  );
};

export default TipReadyToEarnMoreCredit;
